var exports = {
  "a": "DesktopDownloadNagbar.module__platformIcons___SXpBNW",
  "t": "DesktopDownloadNagbar.module__platformIcon___SXpBNW",
};

module.exports = exports;
